__turbopack_context__.v({
  "header": "MinimalHeader-module-scss-module__LDbb2W__header",
  "logo": "MinimalHeader-module-scss-module__LDbb2W__logo",
  "logo-container": "MinimalHeader-module-scss-module__LDbb2W__logo-container",
  "logo-image": "MinimalHeader-module-scss-module__LDbb2W__logo-image",
});
